<template>
  <div>
    {{ msg }}
  </div>
</template>

<script>
export default {
    data() {
        return {
            msg: '',
        };
    },
    created() {
        this.msg = this.$attrs.msg;
    },
};
</script>
